import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { addExtras } from 'apps/auth/actions/extraAction';
import { updateFields } from 'apps/auth/actions/formAction';
import FeePanel from 'apps/auth/components/common/FeePanel/FeePanel';
import { AMOUNT_FROM, AMOUNT_TO } from 'apps/auth/constants/fieldsName';

import { Calculator } from './Calculator';
import { CalculatorFrame } from '../../common/Calculator/styles';

const CalculatorScreen = (props) => {
    return (
        <CalculatorFrame>
            <Calculator
                isBonus={props.isBonus}
                isRepeat={props.isRepeat}
                isCanCalcCommission={props.isCanCalcCommission}
                formName={props.formName}
                fetchCommissionUrl={props.fetchCommissionUrl}
                currencyFrom={props.currencyFrom}
                currencyTo={props.currencyTo}
                isSend={props.isSend}
                getValidationError={props.getValidationError}
                currenciesFrom={props.currenciesFrom}
                currenciesTo={props.currenciesTo}
                typeOfTransfer={props.typeOfTransfer}
                onSelectCurrencyClick={props.onSelectCurrencyClick}
                fromCountryFlagName={props.fromCountryFlagName}
                setDisabledSubmitButton={props.setDisabledSubmitButton}
            />
            <FeePanel
                isBonus={props.isBonus}
                formName={props.formName}
                fromCurrencyIso={props.currencyFrom?.code}
                currencyToIso={props.currencyTo?.code}
                promoCodeFetchUrl={props.promoCodeFetchUrl}
                beforeSaveMoneyCodeSubmit={props.beforeSaveMoneyCodeSubmit}
                amountFrom={props.amountFrom}
            />
        </CalculatorFrame>
    );
};

CalculatorScreen.propTypes = {
    fetchCommissionUrl: PropTypes.string,
    currencyFrom: PropTypes.object,
    currencyTo: PropTypes.object,
    currenciesFrom: PropTypes.array,
    currenciesTo: PropTypes.array,
    isSend: PropTypes.bool,
    isRepeat: PropTypes.bool,
    isCanCalcCommission: PropTypes.bool,
    getValidationError: PropTypes.func,
    onSelectCurrencyClick: PropTypes.func,
    onContinueButtonClick: PropTypes.func,
    promoCodeFetchUrl: PropTypes.string,
    beforeSaveMoneyCodeSubmit: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => ({
    continue: state.messages.pageMessages.continue,
    amountFrom: state.form[ownProps.formName].fields[AMOUNT_FROM],
    amountTo: state.form[ownProps.formName].fields[AMOUNT_TO],
});
export default connect(mapStateToProps, {
    updateFields,
    addExtras,
})(CalculatorScreen);
